module.exports = "/images/vendor/flag-icon-css/flags/1x1/hu.svg?e5e334fdd028898fe762fe6b9d47b6f1";